import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FieldBase from './FieldBase';

export default class TextArea extends Component {
  static propTypes = {
    value: PropTypes.string,
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    submitted: PropTypes.bool,
  };

  static defaultProps = {
    value: '',
  };

  textEntered = e => {
    const textValue = e.target.value;
    this.props.onChange(textValue);
  };
  render() {
    return (
      <FieldBase {...this.props}>
        <textarea
          onChange={this.textEntered}
          className={'textarea ' + (this.props.required && this.props.submitted && this.props.value === '' ? 'error' : '')}
          value={this.props.value}
        />
      </FieldBase>
    );
  }
}
